import { XMarkIcon } from '@heroicons/react/24/outline';

interface SettingsModalProps {
  isOpen: boolean;
  onClose: () => void;
  appId: string;
  userId: string;
  onAppIdChange: (value: string) => void;
  onUserIdChange: (value: string) => void;
  onSave: () => void;
}

const SettingsModal = ({ 
  isOpen, 
  onClose, 
  appId, 
  userId, 
  onAppIdChange, 
  onUserIdChange, 
  onSave 
}: SettingsModalProps) => {
  if (!isOpen) return null;
  
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div 
        className="absolute inset-0 bg-black/50"
        onClick={onClose}
      />
      <div className="relative bg-white rounded-xl shadow-lg p-6 z-10 w-[90%] max-w-md">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">Authentication Settings</h2>
          <button 
            onClick={onClose}
            className="p-1 hover:bg-gray-100 rounded-full"
          >
            <XMarkIcon className="w-6 h-6" />
          </button>
        </div>
        
        <p className="text-sm text-gray-600 mb-4">
          These credentials will be sent with each WebSocket connection for authentication.
        </p>
        
        <div className="space-y-4">
          <div>
            <label htmlFor="appId" className="block text-sm font-medium text-gray-700 mb-1">
              App ID <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              id="appId"
              value={appId}
              onChange={(e) => onAppIdChange(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#4F5DFF] focus:border-transparent"
              placeholder="Enter your App ID"
            />
            <p className="mt-1 text-xs text-gray-500">Required for authentication</p>
          </div>
          <div>
            <label htmlFor="userId" className="block text-sm font-medium text-gray-700 mb-1">
              User ID
            </label>
            <input
              type="text"
              id="userId"
              value={userId}
              onChange={(e) => onUserIdChange(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#4F5DFF] focus:border-transparent"
              placeholder="Enter your User ID (optional)"
            />
            <p className="mt-1 text-xs text-gray-500">Optional identifier for user-specific data</p>
          </div>
        </div>
        
        <div className="mt-6 flex justify-end">
          <button
            onClick={onSave}
            className="px-4 py-2 bg-[#4F5DFF] text-white rounded-lg hover:bg-[#4F5DFF]/90"
          >
            Save & Connect
          </button>
        </div>
      </div>
    </div>
  );
};

export default SettingsModal; 